import { Grid } from "@mui/material";
import React from "react";
import "../assets/styles/about.css";
import downloadIcon from "../assets/image/downloadResumeIcon.png";
import Signature from "../assets/image/signature.png";
import Resume from "../assets/resume/MUHAMMAD JUNAIDResume.pdf";
const About = () => {
  return (
    <div id="about" className="about_container">
      <div className="about_content">
        <Grid container>
          <Grid item xs={12} md={1}></Grid>
          <Grid item xs={12} md={5}>
            <div className="about_info_experience_container">
              <div className="year">
                <h2>1.5</h2>
              </div>
              <div className="experience">
                <p>Years of Experience</p>
              </div>
              <div className="name">
                <p>junaid</p>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={5}>
            <div className="about_section_container">
              <p className="about_me_title">About Me</p>
              <div className="about_me_info">
                <p>
                  As a professional React developer with 1.5 years of
                  experience, I have had the opportunity to work on a wide range
                  of projects, from small internal tools to large-scale web
                  applications. One of the most notable projects I have worked
                  on is a complex web-based platform for a e-commerce services
                  company. The project involved building a highly interactive
                  and user-friendly interface using the latest features of
                  React, such as hooks and the context API. I also utilized
                  Redux for state management, and implemented server-side
                  rendering to improve the performance and SEO of the
                  application. <br /> I worked closely with the design team to
                  ensure that the final product met the client's aesthetic and
                  usability requirements. I also collaborated with the back-end
                  developers to integrate the front-end with the company's
                  RESTful APIs and to ensure that the data was being handled
                  securely. <br /> One of the biggest challenges I faced on this
                  project was managing the complexity of the application's
                  state. I utilized best practices such as immutability and
                  normalized state to ensure that the application was
                  maintainable and scalable.
                  <br />
                  Overall, this project was a great opportunity to apply my
                  skills and experience as a React developer and to work with a
                  talented team to deliver a high-quality product. It also
                  helped me to improve my technical skills and problem solving
                  abilities.
                </p>
              </div>
              <div className="about_download_resume">
                <a href={Resume} download>
                  Download Resume
                  <img src={downloadIcon} alt="downloadIcon" />
                </a>
                <div className="about_me_signature">
                  <img src={Signature} alt="Signature" />
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={1}></Grid>
        </Grid>
      </div>
    </div>
  );
};

export default About;
